import React, { ReactElement, ReactNode, useState } from 'react'
import { Card, CardCategory, CardFooter, CardHeader, CardIcon, CardTitle, Icons } from '@fabricks/ui-components'
import { isNil as _isNil } from 'lodash'
import { Skeleton } from '@material-ui/lab'

interface MetricCardElementProps {
    initLoadingTime?: number
    data?: any
    iconColor?: 'primary' | 'warning' | 'error' | 'default' | 'danger'
    isLoading?: boolean
    valid?: any
    title?: any
    icon?: ReactNode
    value?: number | null
    ofValue?: number | null
    statusMessage?: string
    statusType?: 'warning' | 'error' | 'success'
    unit?: string
    styles?: any
    onClickMetric?: (event: any) => void
    onClickMetricStatus?: (event: any) => void
}

export interface MetricCardStatus {
    status?: 'warning' | 'error' | 'success'
    message?: string
}

interface MetricCardStatusProps {
    type?: 'warning' | 'error' | 'success'
    message?: string
    onClick?: (event: any) => void
}

const MetricCardStatus: React.FC<MetricCardStatusProps> = (props: MetricCardStatusProps) => {
    const { message, type, onClick } = props
    const messageString = message || ''

    if (type === 'warning') {
        return (
            <div style={{ color: '#ffa726', cursor: 'pointer' }} onClick={onClick}>
                <Icons.Warning />
                <span> {messageString} </span>
            </div>
        )
    }
    if (type === 'success') {
        return (
            <div style={{ color: 'rgb(144, 238, 2)', cursor: 'pointer'  }} onClick={onClick}>
                <Icons.Check />
                <span> {messageString} </span>
            </div>
        )
    }
    if (type === 'error') {
        return (
            <div style={{ color: '#d32f2f', cursor: 'pointer'  }} onClick={onClick}>
                <Icons.Error />
                <span> {messageString} </span>
            </div>
        )
    }

    return null
}

export const MetricCardElement: React.FC<MetricCardElementProps> = (props: MetricCardElementProps) => {
    const {
        iconColor,
        value,
        ofValue,
        isLoading,
        title,
        icon,
        statusType,
        statusMessage,
        unit,
        onClickMetric,
        initLoadingTime,
        onClickMetricStatus,
    } = props

    const [initLoading, setInitLoading] = useState((initLoadingTime || 0) > 0)
    const valueString = !_isNil(value)  ? `${value}` : ''
    const ofValueString = ofValue ? `/ ${ofValue} ${unit || ''}` : undefined

    if (isLoading || initLoading) {
        setTimeout(() => setInitLoading(false), initLoadingTime)
        return (
            <Card className="card">
                <CardHeader isStats={false} hasIcon type="plain">
                    <CardIcon className={`${iconColor}-card`} color={iconColor}><div>{icon}</div></CardIcon>
                    <Skeleton
                        variant="text"
                        animation="wave"
                        width="80%"
                        height={20}
                        style={{ marginTop: '10px', float: 'right' }}
                    />
                    <Skeleton
                        variant="text"
                        animation="wave"
                        width="80%"
                        height={20}
                        style={{ float: 'right' }}
                    />
                    <Skeleton
                        variant="text"
                        animation="wave"
                        width="100%"
                        height={20}
                        style={{ float: 'right' }}
                    />
                </CardHeader>
                <CardFooter isStats={false}>
                    <Skeleton
                        variant="rect"
                        animation="wave"
                        width="100%"
                        height={20}
                        style={{ marginBottom: '5px' }}
                    />
                </CardFooter>
            </Card>
        )
    }

    return (
        <Card className="card">
            <CardHeader isStats={false} hasIcon type="plain">
                <CardIcon  className={`${iconColor}-card`}  color={iconColor}>{icon}</CardIcon>
                <CardCategory title={title} />
                <CardTitle title={valueString} variant="h3" unit={ofValueString} padding="0" />
            </CardHeader>
            <CardFooter isStats={false}>
                <MetricCardStatus type={statusType} message={statusMessage} onClick={onClickMetricStatus} />
            </CardFooter>
        </Card>
    )
}
